import styled from "styled-components";

export const ProcessingModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
